import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { DialedDigitExtractionServerUpdateCallback, FormTemplate, FormTemplateSection } from 'data/template/template.types';
// import * as types from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';
import * as types from 'data/backupRestore/backup.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './dialed-digit-extraction-server-form.scss';
import { FormLayout } from 'components/FormLayout';

type Props = {
  template: FormTemplate,
  data: Partial<types.BackupRequestDTO>
  i18nKeyPrefix?: string
  isEditing?: boolean,
  onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
  onFieldCreateNew?: DialedDigitExtractionServerUpdateCallback
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.BackupRequestDTO
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'BackupRestore.form';

export const BackupRestoreForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  onFieldUpdate = () => null,
  onFieldCreateNew,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const formValues: types.BackupRequestDTO = {
      ...mainRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="dialed-digit-extraction-server-form" data-testid="DialedDigitExtractionServerForm">
      <div data-testid="DialedDigitExtractionServerFormMain">
        <FormLayout>
          <Form
            ref={mainRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template.main as FormTemplateSection).fields}
            layout={(template.main as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
            fieldCreateNewHandler={onFieldCreateNew}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default BackupRestoreForm;
